import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import ContactItem from '../../../../contact/ContactItem'
import CustomerService from '../../../../../../services/Accounting/CustomerService'
import Functions from '../../../../../../../setup/utilities/Functions'
import ContactCreate from '../../../../contact/add/ContactCreate'


const Overview : React.FC = () => {
  const { id } = useParams()
  const [customer, setCustomer] = useState<ICustomer>()
  const [selectedContact, setSelectedContact] = useState<IContact|null>()
  const [actionContact, setActionContact] = useState<string>()
  const [actionAddress, setActionAddress] = useState<string>()
  const [isLoadingContact, setIsLoadingContact] = useState(true)
  const [showContact, setShowContact] = useState(false)
  const intl = useIntl()
  const [showAddress, setShowAddress] = useState(false)
  const [selectedAddress, setSelectedAddress] = useState<IAddress>()
  const handleShowAddress = (selectedAddress: IAddress|null, action : string) => {
    if (selectedAddress) {
      setSelectedAddress(selectedAddress)
    }
    setActionAddress(action)
    setShowAddress(true)
  }
  const handleCloseAddress = () => setShowAddress(false)
  const handleIsLoadingContact = (isLoading: boolean) => {
    setIsLoadingContact(isLoading)
  }

  const handleShowContact = (contact: IContact|null, action: string) => {
    setSelectedContact(contact)
    setActionContact(action)
    setShowContact(true)
  }

  useEffect(() => {}, [selectedAddress])

  const handleCloseContact = async (isSubmit: boolean) => {
    if (!isSubmit) {
      const isConfirmed = await Functions.sweetAlert(
        '<span class="mt-5">' + intl.formatMessage({ id: 'action.message' }) + '</span>',
        'warning',
        true,
        intl.formatMessage({ id: 'action.cancel' }),
        intl.formatMessage({ id: 'action.return' }),
        'btn btn-primary mt-10 mb-10',
        'btn btn-active-light mt-10 mb-10',
      )
      if (isConfirmed) {
        setShowContact(false)
      }
    } else {
      setShowContact(false)
    }
  }

  useEffect(() => {
    CustomerService.getCustomer(id).then((response) => {
      setCustomer(response.data.data)
      setIsLoadingContact(false)
    })
  }, [isLoadingContact, selectedContact])

  return (

    <>
      <div className="card pt-4 mb-6 mb-xl-9">
        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({ id: 'accounting.customer.entity.displayName' })}</label>
            <div className='col-lg-8 fv-row'>
              <span className='fw-bold fs-6'>{customer?.displayName}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({ id: 'accounting.customer.entity.taxRegistrationNumber' })}</label>
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{customer?.taxRegistrationNumber}</span>
              <span className='badge badge-success'>Verified</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({ id: 'accounting.customer.entity.financialCode' })}</label>
            <div className='col-lg-8 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{customer?.financialCode}</span>
              <span className='badge badge-success'>Verified</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({ id: 'accounting.customer.entity.country' })}</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{customer?.country ? customer.country.name : '-'}</span>
            </div>
          </div>
          <div className='row mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>{intl.formatMessage({ id: 'accounting.customer.entity.location' })}</label>
            <div className='col-lg-8'>
              <span className='fw-bolder fs-6 text-dark'>{customer?.location ? customer.location.name : '-'}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='row gy-10 gx-xl-10'>
        {customer?.contacts && customer?.contacts.map((contact, index) => (
          <div className='col-xxl-6' key={`contact_${index}`}>
            <ContactItem isCreate={false} contact={contact} page='list' handleIsLoading={handleIsLoadingContact} handleShow={handleShowContact} isLoading={isLoadingContact}/>
          </div>
        ))}
        <div className='col-xxl-6'>
          <ContactItem isCreate={true} handleShow={handleShowContact} isLoading={isLoadingContact} handleIsLoading={handleIsLoadingContact} page='list' contact={null}/>
        </div>
      </div>
      <ContactCreate
        customer={customer}
        supplier={null}
        handleIsLoading={handleIsLoadingContact}
        contact={selectedContact}
        actionAddress={actionAddress}
        actionContact={actionContact}
        handleCloseAddress={handleCloseAddress}
        handleCloseContact={handleCloseContact}
        handleShowAddress={handleShowAddress}
        showAddress={showAddress}
        showContact={showContact}
        selectedAddress={selectedAddress}/>
    </>
  )
}

export default Overview
